<ng-container *ngIf="datos.tipo == 'tipoResultados'">
  <h2 mat-dialog-title>{{'ACCIONES.SUBACCIONES.' + datos.accion + '.' + datos.subAccion + '.MODAL.TITULO' | translate}}</h2>
  <mat-dialog-content class="mat-typography">
    <p><em>{{'ACCIONES.SUBACCIONES.verRes.tipoResu.MODAL.SUBTITULO' | translate}}</em></p>
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-20 mb-20">
      <p>{{'ACCIONES.SUBACCIONES.verRes.tipoResu.MODAL.SINCERT' | translate}}</p>
      <mat-slide-toggle [(ngModel)]="tipoResultados" class="ml-20 mr-20" (change)="cambiaTipoResultados()"></mat-slide-toggle>
      <p>{{'ACCIONES.SUBACCIONES.verRes.tipoResu.MODAL.CONCERT' | translate}}</p>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="accent" class="mt-20" (click)="salir_tipoResu()">
      {{'HISTORIAL_MAILS.MODAL.BOTONES.BACK' | translate}}
      <mat-icon class="ml-20">arrow_back</mat-icon>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="datos.tipo == 'auditoriaManual'">
  <h2 mat-dialog-title>{{'ACCIONES.SUBACCIONES.AUDMANUAL.TITULO' | translate}}</h2>
  <mat-dialog-content class="mat-typography">
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-20 mb-20">
      <p>{{'ACCIONES.SUBACCIONES.AUDMANUAL.STATUS.OFF' | translate}}</p>
      <mat-slide-toggle [(ngModel)]="statusAuditoria" class="ml-20 mr-20"></mat-slide-toggle>
      <p>{{'ACCIONES.SUBACCIONES.AUDMANUAL.STATUS.ON' | translate}}</p>
    </div>
    <div fxLayout="column" fxLayoutAlign="start stretch">
      <mat-form-field appearance="outline">
        <mat-label>{{'ACCIONES.SUBACCIONES.AUDMANUAL.NOMBRE' | translate}}</mat-label>
        <input matInput type="text" [(ngModel)]="datos.info.ManualAudit_AuditorName">
        <mat-icon matSuffix class="secondary-text">person</mat-icon>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{'ACCIONES.SUBACCIONES.AUDMANUAL.NOTAS' | translate}}</mat-label>
        <textarea matInput rows="5" [(ngModel)]="datos.info.ManualAudit_Text"></textarea>
        <mat-icon matSuffix class="secondary-text">notes</mat-icon>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="accent" class="mt-20" (click)="salir_SinGuardaraudMan()">
      {{'HISTORIAL_MAILS.MODAL.BOTONES.BACK' | translate}}
      <mat-icon class="ml-20">arrow_back</mat-icon>
    </button>
    <button mat-raised-button color="primary" class="mt-20 dialog_confirmar" (click)="salir_GuadaraudMan()">
      {{'HISTORIAL_MAILS.MODAL.BOTONES.SAVE' | translate}}
      <mat-icon class="ml-20">save</mat-icon>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="datos.tipo == 'verRecordatorios'">
  <ng-container *ngIf="datos.recordatorios.recordatoriosFullInfo.length > 0">
    <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.PASO3.TIUTLOLISTA' | translate}}</h2>
    <mat-dialog-content class="mat-typography">
      <p><b>{{'SHEDULE2_0.CARDS.PASO3.INFOHORA' | translate}} {{horaInstitutoTag|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{'SHEDULE2_0.ZONAS.'+datos.recordatorios.indiceZona | translate}} {{horaInstitutoTag|date:'z':offsetPipe:idiomaActual}})</b></p>
      <mat-list class="tac">
        <mat-list-item *ngFor="let fecha of datos.recordatorios.recordatoriosFullInfo; index as i; last as last">
          <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
          <h4 mat-line>{{fecha.fechaRecordatorio|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{fecha.fechaRecordatorio|date:'z':offsetPipe:idiomaActual}})</h4>
          <mat-form-field class="calHid">
              <input matInput [matDatepicker]="recordatorioFechas" [matDatepickerFilter]="filtroRecordatorios" (dateChange)="fechaRecordatorio(2, $event)">
              <mat-datepicker touchUi #recordatorioFechas>
                <!-- <mat-datepicker-actions>
      <button mat-button matDatepickerCancel>Cancel</button>
    </mat-datepicker-actions> -->
              </mat-datepicker>

          </mat-form-field>
          <div class="calHid">
              <input placeholder="12hr format (default settings)" aria-label="12hr format" [ngxTimepicker]="horaGenerica" [format]="24" id="timepickerRecosUpdat" readonly>
              <ngx-material-timepicker [enableKeyboardInput]="true" (timeSet)="horaSeleccionadaRecoUpdate($event)" [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="confirmBtn" [editableHintTmpl]="dialHint" #horaGenerica></ngx-material-timepicker>
              <ng-template #cancelBtn>
                  <button mat-raised-button color="accent" class="wsn m-20">{{'SHEDULE2_0.CARDS.FECHAS.BOTONES.CANCELAR' | translate}}</button>
              </ng-template>
              <ng-template #confirmBtn>
                  <button mat-raised-button color="accent" class="wsn m-20">{{'SHEDULE2_0.CARDS.FECHAS.BOTONES.ACEPTAR' | translate}}</button>
              </ng-template>
              <ng-template #dialHint>
                  <b class="fechaSel">{{'SHEDULE2_0.CARDS.FECHAS.FECHA' | translate}}{{fechaRecoTemp}}</b>
              </ng-template>
          </div>
          <button mat-mini-fab color="warn" class="margBtn" (click)="updRecordatorio(fecha, i)" [disabled]="fechaActualNave.isAfter(fecha.fechaRecordatorio)">
            <span class="material-icons-outlined">edit_calendar</span>
          </button>
          <button mat-mini-fab color="warn" (click)="borraRecordatorio(fecha.fechaRecordatorio, i)" [disabled]="fechaActualNave.isAfter(fecha.fechaRecordatorio)">
            <mat-icon>delete_forever</mat-icon>
          </button>
          <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
        </mat-list-item>
      </mat-list>
    </mat-dialog-content>
  </ng-container>
  <ng-container *ngIf="datos.recordatorios.recordatoriosFullInfo.length == 0">
    <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.PASO3.NORECOS' | translate}}</h2>
  </ng-container>

  <div mat-dialog-actions align="center">
    <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
      {{'SHEDULE2_0.CERRAR' | translate}}
      <mat-icon class="ml-20">clear</mat-icon>
    </button>
  </div>


</ng-container>


<ng-container *ngIf="datos.tipo == 'verAvisos'">
  <ng-container *ngIf="datos.datosAvisos.fechasAvisos.length > 0">
    <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.PASO3.TITULOLISTA' | translate}}</h2>
    <mat-dialog-content class="mat-typography">
      <p><b>{{'SHEDULE2_0.CARDS.PASO3.INFOHORAAVISO' | translate}} {{horaInstitutoTag|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{'SHEDULE2_0.ZONAS.'+datos.datosAvisos.indiceZona | translate}} {{horaInstitutoTag|date:'z':offsetPipe:idiomaActual}})</b></p>
      <mat-list class="tac">
        <mat-list-item *ngFor="let fecha of datos.datosAvisos.fechasAvisos; index as i; last as last">
          <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
          <h4 mat-line *ngIf="datos.datosAvisos.tipoProducto!=63">{{fecha.aviso|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{fecha.aviso|date:'z':offsetPipe:idiomaActual}})</h4>
          <h4 mat-line *ngIf="datos.datosAvisos.tipoProducto==63">{{fecha.fechaRecordatorio|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{fecha.fechaRecordatorio|date:'z':offsetPipe:idiomaActual}})</h4>
          <mat-form-field class="calHid">
              <input matInput [matDatepicker]="avisoFechas" [matDatepickerFilter]="filtroAviso" (dateChange)="fechaAviso(2, $event,fecha.aviso,i)">
              <mat-datepicker touchUi #avisoFechas></mat-datepicker>
          </mat-form-field>
          <div class="calHid">
              <input placeholder="12hr format (default settings)" aria-label="12hr format" [ngxTimepicker]="horaGenerica" [format]="24" id="timepickerAvisoUpdat" readonly>
              <ngx-material-timepicker [enableKeyboardInput]="true" (timeSet)="horaSeleccionadaAviUpdate($event)" [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="confirmBtn" [editableHintTmpl]="dialHint" #horaGenerica></ngx-material-timepicker>
              <ng-template #cancelBtn>
                  <button mat-raised-button color="accent" class="wsn m-20">{{'SHEDULE2_0.CARDS.FECHAS.BOTONES.CANCELAR' | translate}}</button>
              </ng-template>
              <ng-template #confirmBtn>
                  <button mat-raised-button color="accent" class="wsn m-20">{{'SHEDULE2_0.CARDS.FECHAS.BOTONES.ACEPTAR' | translate}}</button>
              </ng-template>
              <ng-template #dialHint>
                  <b class="fechaSel">{{'SHEDULE2_0.CARDS.FECHAS.FECHA' | translate}}{{fechaRecoTemp}}</b>
              </ng-template>
          </div>
          <ng-container *ngIf="datos.datosAvisos.tipoProducto!=63">
            <button mat-mini-fab color="warn" class="margBtn" (click)="updFechaAviso(fecha, i)" [disabled]="fechaActualNave.isAfter(fecha.aviso)">
              <span class="material-icons-outlined">edit_calendar</span>
            </button>
            <button mat-mini-fab color="warn" (click)="borrarAviso(fecha.aviso, i)" [disabled]="fechaActualNave.isAfter(fecha.aviso)">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </ng-container>
          <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
        </mat-list-item>
      </mat-list>
    </mat-dialog-content>
  </ng-container>
  <ng-container *ngIf="datos.datosAvisos.fechasAvisos.length == 0">
       <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.PASO3.NOAVI' | translate}}</h2>
  </ng-container>

  <div mat-dialog-actions align="center">
    <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
      {{'SHEDULE2_0.CERRAR' | translate}}
      <mat-icon class="ml-20">clear</mat-icon>
    </button>
  </div>


</ng-container>

<ng-container *ngIf="datos.tipo == 'certifica'">
  <ng-container >
    <div class=""fxLayout="row" fxLayoutAlign="center center">
      <h2 mat-dialog-title> {{'DAT_CERTI.TIT_MOD' | translate}}</h2>

    </div>
    <mat-dialog-content class="mat-typography">
      <div class="" fxLayout="column" fxLayoutAlign="space-between center">
        <div class=""  fxLayout="row" fxLayoutAlign="space-between center" >
          <h3>{{'DAT_CERTI.ING_DAT' | translate}}</h3>
          <mat-form-field appearance="outline" class="mfc">
            <input matInput  [matDatepickerFilter]="filtroFechaCertificado" [matDatepicker]="picker"  (dateChange)="fechaSeleccionadaCertificado($event)"  [(ngModel)]="dateFechaDemoCertificado">
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <button mat-mini-fab color="primary" (click)="picker.open()">
            <mat-icon>calendar_today</mat-icon>
          </button>
        </div>
          <div class=""  fxLayout="row" fxLayoutAlign="space-between center" >
            <h3>{{'DAT_CERTI.ING_RAS' | translate}}</h3>
        <mat-form-field class="example-full-width" appearance="outline" fxFlex="100">
          <textarea matInput [(ngModel)]="reasonUpdateCertifi"></textarea>
        </mat-form-field>
      </div>

      </div>

    </mat-dialog-content>
    <div mat-dialog-actions align="end">
      <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
        {{'SHEDULE2_0.CARDS.FECHAS.BOTONES.CANCELAR' | translate}}
        <mat-icon class="ml-20">arrow_back</mat-icon>
      </button>
      <button mat-raised-button color="primary" class="mt-20 dialog_confirmar" (click)="salir_UpdateDateCerti()">
      {{'DAT_CERTI.BTN_SAV' | translate}}
        <mat-icon class="ml-20">save</mat-icon>
      </button>
    </div>
  </ng-container>
  <!-- <ng-container *ngIf="datos.datosAvisos.fechasAvisos.length == 0">
       <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.PASO3.NOAVI' | translate}}</h2>
  </ng-container> -->



</ng-container>

<ng-container *ngIf="datos.tipo == 'verFechIniCie'">
  <ng-container *ngIf="datos.datosDateStartEnd">
    <h2 mat-dialog-title>{{'DAT_STAEND.TIT_MOD' | translate}}</h2>
    <mat-dialog-content class="mat-typography">
      <p><b>{{'DAT_STAEND.SUB_TIT_MOD' | translate}} {{horaInstitutoTag|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{'SHEDULE2_0.ZONAS.'+datos.datosDateStartEnd.indiceZona | translate}} {{horaInstitutoTag|date:'z':datos.datosDateStartEnd.offsetPipe:idiomaActual}})</b></p>
      <!-- <p><b>{{'SHEDULE2_0.CARDS.PASO3.INFOHORA' | translate}} {{horaInstitutoTag|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{'SHEDULE2_0.ZONAS.'+datos.datosDateStartEnd.indiceZona | translate}} {{horaInstitutoTag|date:'z':offsetPipe:idiomaActual}})</b></p> -->
      <mat-list class="tac">
        <div mat-subheader>{{'DAT_STAEND.TEX_DA_STA' | translate}}</div>
        <mat-list-item>
          <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
          <h4 mat-line>{{fechaLanzamiento|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{fechaLanzamiento|date:'z':offsetPipe:idiomaActual}})</h4>
          <mat-form-field class="calHid">
              <input matInput [matDatepicker]="dateStartEnd" [matDatepickerFilter]="filtroDate" (dateChange)="datStarEndSurvey('lanza', $event)">
              <mat-datepicker touchUi #dateStartEnd></mat-datepicker>
          </mat-form-field>
          <button mat-mini-fab color="warn" class="margBtn" (click)="updStarEndDate('lanza')">
            <span class="material-icons-outlined">edit_calendar</span>
          </button>
          <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
        </mat-list-item>
      </mat-list>
      <mat-list class="tac">
        <div mat-subheader>{{'DAT_STAEND.TEX_DA_EN' | translate}}</div>
        <mat-list-item>
          <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
          <h4 mat-line>{{fechaCierre|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{fechaCierre|date:'z':offsetPipe:idiomaActual}})</h4>
          <mat-form-field class="calHid">
              <input matInput [matDatepicker]="dateStartEnd2" [matDatepickerFilter]="filtroDate" (dateChange)="datStarEndSurvey('cierre', $event)">
              <mat-datepicker touchUi #dateStartEnd2></mat-datepicker>
          </mat-form-field>
          <button mat-mini-fab color="warn" class="margBtn" (click)="updStarEndDate('cierre')">
            <span class="material-icons-outlined">edit_calendar</span>
          </button>
          <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
        </mat-list-item>
      </mat-list>
      <div class="calHid">
          <input placeholder="12hr format (default settings)" aria-label="12hr format" [ngxTimepicker]="horaGenerica" [format]="24" [min]="filtroHoraHoy" id="timepickerStaEndUpdat" readonly>
          <ngx-material-timepicker [enableKeyboardInput]="true" (closed)="salirSinHora($event)"   (timeSet)="horaSeleccionadaStarEndUpdate($event)" [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="confirmBtn" [editableHintTmpl]="dialHint" #horaGenerica></ngx-material-timepicker>
          <ng-template #cancelBtn>
              <button mat-raised-button color="accent" class="wsn m-20">{{'SHEDULE2_0.CARDS.FECHAS.BOTONES.CANCELAR' | translate}}</button>
          </ng-template>
          <ng-template #confirmBtn>
              <button mat-raised-button color="accent" class="wsn m-20">{{'SHEDULE2_0.CARDS.FECHAS.BOTONES.ACEPTAR' | translate}}</button>
          </ng-template>
          <ng-template #dialHint>
              <b class="fechaSel">{{'SHEDULE2_0.CARDS.FECHAS.FECHA' | translate}}{{fechaRecoTemp}}</b>
          </ng-template>
      </div>
    </mat-dialog-content>
  </ng-container>
  <!-- <ng-container *ngIf="datos.recordatorios.recordatoriosFullInfo.length == 0">
    <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.PASO3.NORECOS' | translate}}</h2>
  </ng-container> -->

  <div mat-dialog-actions align="center">
    <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
      {{'SHEDULE2_0.CERRAR' | translate}}
      <mat-icon class="ml-20">clear</mat-icon>
    </button>
  </div>


</ng-container>

<ng-container *ngIf="datos.tipo == 'selectIdiomaCertificado'">
<div class="" fxLayout="column">
  <h2 mat-dialog-title>{{'LANG_CERT.TIT_MOD' | translate}}</h2>
  <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
    <mat-label>{{'LANG_CERT.TIT_MOD' | translate}}</mat-label>
    <mat-select class="selectLangs" placeholder="{{'DESCARGAR_ENCUESTA.MODAL.PLACEHOLDER' | translate}}">
      <mat-option *ngFor="let lang of languages" [value]="lang.id" (click)="selIdiomaCertificado(lang)">
        {{'SELECTOR.'+lang.id | translate}}
      </mat-option>
    </mat-select>
    <mat-error></mat-error>
  </mat-form-field>
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
      {{'HISTORIAL_MAILS.MODAL.BOTONES.BACK' | translate}}
      <mat-icon class="ml-20">arrow_back</mat-icon>
    </button>

    <button mat-raised-button color="accent" class="mt-20" (click)="salir_IdiomaCertificado()" [disabled]="langSelection==''">
      {{'SHEDULE2_0.CARDS.FECHAS.BOTONES.ACEPTAR' | translate}}
      <mat-icon class="ml-20">check</mat-icon>
    </button>
  </div>

</div>

</ng-container>

<ng-container *ngIf="datos.tipo == 'cambiaCultureBrief'">
  <h2 mat-dialog-title>{{'ACCIONES.SUBACCIONES.cambiaCultureBrief.TITULO' | translate}}</h2>
  <div fxLayout="column" fxLayoutAlign="start center" class="p-20" *ngIf="pasoCultBrf == 0">
      <p>{{'MENU_PRODUCTOS.CARGANDO' | translate}}</p>
      <mat-spinner class="m-20" *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
  </div>
  <mat-dialog-content class="mat-typography" *ngIf="pasoCultBrf != 0">
    <p *ngIf="prodCultBrf_curr == undefined"><em>{{'ACCIONES.SUBACCIONES.cambiaCultureBrief.STATUS_SIN' | translate}}</em></p>
    <p *ngIf="prodCultBrf_curr != undefined"><em>{{'ACCIONES.SUBACCIONES.cambiaCultureBrief.STATUS_CON' | translate}}</em></p>
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-20 mb-20" *ngIf="prodCultBrf_curr != undefined">
      <p><b>{{'CONSULTATABLA.PRODUCTOS.' + prodCultBrf_curr.tipo | translate}}</b></p>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-20 mb-20" *ngIf="pasoCultBrf == 1">
      <button mat-raised-button color="primary" class="mt-20" (click)="pasoCultBrf = 2">
        {{'ACCIONES.SUBACCIONES.cambiaCultureBrief.BOTON_ELEGIR' | translate}}
        <mat-icon class="ml-20">sync</mat-icon>
      </button>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-20 mb-20" *ngIf="pasoCultBrf == 2">
      <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
        <mat-label>{{'ACCIONES.SUBACCIONES.cambiaCultureBrief.LISTA_ELEGIR' | translate}}</mat-label>
        <mat-select class="selectLangs" placeholder="{{'ACCIONES.SUBACCIONES.cambiaCultureBrief.LISTA_DISPONIBLES' | translate}}">
          <mat-option *ngFor="let prodCAB of listaCultBrf" [value]="prodCAB" (click)="prodCultBrf_temp = prodCAB">
            <ng-container *ngIf="prodCAB.tipo != undefined">
              {{'CONSULTATABLA.PRODUCTOS.' + prodCAB.tipo | translate}}
            </ng-container>
            <ng-container *ngIf="prodCAB.tipo == undefined">
              {{'ACCIONES.SUBACCIONES.cambiaCultureBrief.SIN_OPCIONES' | translate}}
            </ng-container>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-raised-button color="primary" class="ml-20" (click)="asociarCultureBrief()" [disabled]="prodCultBrf_temp.tipo == undefined">
        {{'ACCIONES.SUBACCIONES.cambiaCultureBrief.BOTON_ELEGIR_2' | translate}}
        <mat-icon class="ml-20 mr-20">done</mat-icon>
      </button>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
      {{'HISTORIAL_MAILS.MODAL.BOTONES.BACK' | translate}}
      <mat-icon class="ml-20">arrow_back</mat-icon>
    </button>
  </div>
</ng-container>
